export default "__VITE_ASSET__Bt2175In__"